module.exports = __webpack_public_path__ + "img/eraser25.d192fed5.png";